var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 52.3333V52.7C40.0001 53.6333 39.2667 54.3667 38.3334 54.3667H8.33341C7.40008 54.3667 6.66675 53.6333 6.66675 52.7V52.3333C6.66675 46.4667 8.13341 45 14.0667 45H32.6001C38.5334 45 40.0001 46.4667 40.0001 52.3333Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 57.7C7.40008 57.7 6.66675 58.4333 6.66675 59.3666V62.7V66C6.66675 71.8666 8.13341 73.3333 14.0667 73.3333H32.6001C38.5334 73.3333 40.0001 71.8666 40.0001 66V62.7V59.3666C40.0001 58.4333 39.2667 57.7 38.3334 57.7H8.33341Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 50C73.3333 62.9 62.9 73.3333 50 73.3333L53.5 67.5",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 30C6.66675 17.1 17.1001 6.66663 30.0001 6.66663L26.5001 12.5",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6667 36.6666C69.951 36.6666 76.6667 29.9509 76.6667 21.6666C76.6667 13.3824 69.951 6.66663 61.6667 6.66663C53.3825 6.66663 46.6667 13.3824 46.6667 21.6666C46.6667 29.9509 53.3825 36.6666 61.6667 36.6666Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.67f6217bc425dad8a751ddf8f76069c4.svg";
export { ForwardRef as ReactComponent };